export const themeD = {
  name: "墨金典藏",
  colors: {
    bg: "#0C0A09",
    bgSecondary: "#1A1714",
    text: "#F5F0E8",
    textSecondary: "#BFB8A8",
    textMuted: "#948A78",
    accent: "#C9A84C",
    accentText: "#1A1714",
    accentAlt: "#D4A853",
    accentWarm: "#E2C87E",
    accentOrange: "#D4A24C",
    available: "#A8B864",
    availableText: "#1A1714",
    claimed: "#3D3830",
    cardBg: "#161310",
    cardBorder: "#2E2922",
    overlay: "rgba(12,10,9,0.8)",
    heroBg: "#0C0A09",
    heroText: "#F5F0E8",
  },
  fonts: {
    // Playfair loads dynamically via fontUrls when this theme activates.
    heading: "'Playfair Display', 'Noto Serif TC', serif",
    body: "'Noto Sans TC', sans-serif",
    accent: "'Playfair Display', serif",
  },
  fontUrls: [
    "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&display=swap",
  ],
  radius: { sm: "4px", md: "8px", lg: "12px", full: "9999px" },
  spacing: { cardGap: "20px", sectionGap: "56px", pagePadding: "20px" },
  effects: {
    cardShadow: "0 2px 16px rgba(201,168,76,0.06)",
    cardHoverShadow: "0 4px 24px rgba(201,168,76,0.12)",
    bgTexture: true,
    textureOpacity: 0.02,
  },
};
